export default {
  name: 'header-without-menu',
  methods: {
    selectLang (lang) {
      let route = this.$route
      let params = route.params
      params.lang = lang
      this.$router.push({
        name: route.name,
        query: route.query,
        params: params
      })
      // this.show = !this.show
    },
    redirectConsult() {
      window.open('https://talk.naver.com/ct/w5wmn6', '_blank')
    }
  }
}
